// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-block-title {
  display: none;
}

.header-logo {
  margin-right: 20px;
}

.sidebar-block-title {
  padding: 2em 3em 3em 4em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.sidebar-logo {
  margin-right: 7%;
}

@media screen  and (max-width: 1350px) {
  .sidebar-block-title {
    padding: 2em 3em 3em 4em;
    flex-direction: column;
  }

  .sidebar-logo {
    margin-bottom: 1.5em;
  }
}

@media screen  and (max-width: 1050px) {
  .header-block-title{
    display: flex;
  }
  .header-text{
    width: 70%;
  }
}

@media screen  and (max-width: 480px) {
  .header-block-title{
    justify-content: center;
  }
  .header-logo {
    display: none;
  }
  .header-text{
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderTitle/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".header-block-title {\n  display: none;\n}\n\n.header-logo {\n  margin-right: 20px;\n}\n\n.sidebar-block-title {\n  padding: 2em 3em 3em 4em;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-logo {\n  margin-right: 7%;\n}\n\n@media screen  and (max-width: 1350px) {\n  .sidebar-block-title {\n    padding: 2em 3em 3em 4em;\n    flex-direction: column;\n  }\n\n  .sidebar-logo {\n    margin-bottom: 1.5em;\n  }\n}\n\n@media screen  and (max-width: 1050px) {\n  .header-block-title{\n    display: flex;\n  }\n  .header-text{\n    width: 70%;\n  }\n}\n\n@media screen  and (max-width: 480px) {\n  .header-block-title{\n    justify-content: center;\n  }\n  .header-logo {\n    display: none;\n  }\n  .header-text{\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
